import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  container: {
    borderRadius: theme.sizes.roundCorners,
    backgroundColor: theme.colors.panel_background,
    overflow: 'hidden'
  },
  containerDark: {
    backgroundColor: theme.colors.card_background_secondary,
    padding: '24px 32px',
    ...reskinStyles(theme, { ...theme.cardStyles.outlined, margin: 0, width: '100%' })
  }
});

export default styles;
